module.exports = __webpack_public_path__ + "static/media/s3.30376eb0.jpg";